module.exports = __webpack_public_path__ + "static/img/sina.b3118b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sina.png
// module id = VVTU
// module chunks = 0